'use client';

// Zone d'authentification — split éditorial premium plein écran : panneau immersif
// (photos souvenirs qui dérivent, voilées de crème + accroche serif) à gauche sur
// desktop, formulaire centré verticalement à droite. Sur mobile, le panneau cède
// la place à un en-tête de marque compact. Si déjà connecté → bibliothèque.

import { useRouter } from 'next/navigation';
import { useEffect, type ReactNode } from 'react';

import { BrandWordmark } from '@/components/app/BrandWordmark';
import { AuthShowcase } from '@/components/auth/AuthShowcase';
import { useMe } from '@/queries/auth';

export default function AuthLayout({ children }: { children: ReactNode }) {
  const { data: user } = useMe();
  const router = useRouter();

  useEffect(() => {
    if (user) router.replace('/library');
  }, [user, router]);

  return (
    <div className="grid min-h-[100dvh] lg:grid-cols-[1.05fr_1fr]">
      <AuthShowcase />

      <div className="relative flex min-h-[100dvh] flex-col justify-center overflow-hidden px-6 py-14 sm:px-10 lg:min-h-full lg:px-16">
        {/* Lueur atmosphérique douce (chaleur, cohérence avec le showcase). */}
        <div
          aria-hidden
          className="pointer-events-none absolute -right-32 -top-24 size-[30rem] rounded-full opacity-50 blur-3xl"
          style={{
            background:
              'radial-gradient(circle, var(--rmbr-brand-muted), transparent 68%)',
          }}
        />
        <div className="relative mx-auto w-full max-w-md">
          {/* Marque (mobile uniquement — le showcase la porte sur desktop). */}
          {/* Même pastille de marque que les deux barres de l'application : l'inscription
              est la charnière entre la vitrine et l'application, la marque n'y change pas. */}
          <span className="mb-10 flex w-fit items-center rounded-xl bg-brand px-3.5 py-1.5 text-brand-on lg:hidden">
            <BrandWordmark className="h-7 w-auto" />
          </span>

          <div className="rmbr-reveal" style={{ animationDelay: '120ms' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
